import { FC } from 'react';
import { SearchBarSkeleton } from 'newelements/SearchElement/partials/components/SearchBar/Skeleton';
import './index.less';

export const SearchElementSkeleton: FC = () => {
  return (
    <div className="searchElement">
      <SearchBarSkeleton />
    </div>
  );
};
